export const VisualizationConfigPortalId = 'visualization-config-portal';
